import 'core-js/stable'
import './styles/globals.css'
import { createApp } from 'vue'
import { RouterView } from 'vue-router'

import router from './router'
import { createPinia } from 'pinia'
import { initState } from './views/state'

const app = createApp({
  setup () {
    initState()

    return () => (
      <main>
        <RouterView></RouterView>
      </main>
    )
  },
})
app.use(createPinia()).use(router).mount('#app')
